(function () {

  function initHighlightReveal(root = document) {
    // IMPORTANT : uniquement les spans .mv-h1 à l’intérieur d’un h2 ou d'un h3
    const targets = root.querySelectorAll("h2 span.mv-h1:not(.is-revealed), h3 span.mv-h1:not(.is-revealed)");
    if (!targets.length) return;

    if (!("IntersectionObserver" in window)) {
      targets.forEach(el => el.classList.add("is-revealed"));
      return;
    }

    const io = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
        const el = entry.target;

        // Delay aléatoire léger (entre 80ms et 280ms)
        const delay = Math.floor(80 + Math.random() * 200);
        el.style.setProperty("--mv-delay", `${delay}ms`);

        el.classList.add("is-revealed");
        observer.unobserve(el);
        }
    });
    }, {
    threshold: 0.10,
    rootMargin: "0px 0px -10% 0px"
    });


    targets.forEach(el => io.observe(el));
  }

  // Init (même si le script est chargé après DOMContentLoaded)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initHighlightReveal());
  } else {
    initHighlightReveal();
  }

  // Shopify Theme Editor (sections dynamiques)
  document.addEventListener("shopify:section:load", (e) => initHighlightReveal(e.target));
  document.addEventListener("shopify:section:select", (e) => initHighlightReveal(e.target));

})();


document.querySelectorAll(".slider-outer-wrapper.slider-grid-card-type-overlay")
  .forEach(wrapper => {
    wrapper.classList.add("mv-carousel-hint");

    const ul = wrapper.querySelector("ul.slider-element");
    if (!ul) return;

    // on observe le wrapper (visibilité), mais on ajoute la classe sur le UL
    wrapper.__mvTarget = ul;
  });



(function () {
  const wrappers = document.querySelectorAll(".slider-outer-wrapper.slider-grid-card-type-overlay");
  if (!wrappers.length) return;

  wrappers.forEach(w => w.classList.add("mv-carousel-hint"));

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-nudged");
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.25, rootMargin: "0px 0px -10% 0px" });

  wrappers.forEach(w => io.observe(w));
})();
